"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var useWindowDimensions_1 = require("../../hooks/useWindowDimensions");
var core_1 = require("@material-ui/core");
var EmptyChart = function () {
    var width = (0, useWindowDimensions_1.useWindowDimensions)().width;
    return ((0, jsx_runtime_1.jsx)(EmptyArea, __assign({ width: width }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ variant: "subtitle2" }, { children: "\u30C7\u30FC\u30BF\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F" })) })));
};
var EmptyArea = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n"])), function (props) { return props.width / 3; });
exports["default"] = EmptyChart;
var templateObject_1;
